import { render, staticRenderFns } from "./SalesInsights.vue?vue&type=template&id=96fe1dc4&scoped=true"
import script from "./SalesInsights.vue?vue&type=script&lang=js"
export * from "./SalesInsights.vue?vue&type=script&lang=js"
import style0 from "./SalesInsights.vue?vue&type=style&index=0&id=96fe1dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fe1dc4",
  null
  
)

export default component.exports